import { useEffect, useState } from 'react';
import { useInvokeSWRService } from '@dxb-web-ui-framework/common/hooks';
import { cardService } from '../../../channels/secure-web/services';
import { useSelectedCustomerId } from '../../userProfile/src/contexts/UserInfo/hooks';
import { useCardHeaders, useIsCardHolder } from '../../transaction/src/contexts/Parameters/hooks';
import { CardInfoListFilter, CardInfoListPagination, CardInfoListResponseBody } from '../../card/src/types';

const useGetCards = (filter: CardInfoListFilter, pagination: CardInfoListPagination) => {
  const customerId = useSelectedCustomerId();
  const cardHeaders = useCardHeaders();
  const isCardHolder = useIsCardHolder();
  const [individualCardListData, setIndividualCardListData] = useState<CardInfoListResponseBody | undefined>(undefined);
  const [shouldFetchIndividualCards, setShouldFetchIndividualCards] = useState(false);
  const [timestamp] = useState(new Date().toISOString());

  useEffect(() => {
    if (cardHeaders && customerId && !isCardHolder) {
      setShouldFetchIndividualCards(true);
    }
  }, [cardHeaders]);

  const {
    data: individualCardListDataResponse,
    error: individualCardListDataError,
    isLoading: isLoadingIndividualCardListData,
  } = useInvokeSWRService(
    cardService.GetIndividualCards,
    {
      headers: cardHeaders,
      customerId,
      filter,
      pagination,
      meta: {
        timestamp,
      },
    },
    shouldFetchIndividualCards,
  );

  useEffect(() => {
    if (individualCardListDataResponse) {
      setIndividualCardListData(individualCardListDataResponse);
      setShouldFetchIndividualCards(false);
    }
  }, [individualCardListDataResponse]);

  return {
    cardList: individualCardListData,
    isLoadingCardList: isLoadingIndividualCardListData,
    cardListError: individualCardListDataError,
  };
};

export { useGetCards };
